module.exports = __webpack_public_path__ + "img/selected_regular_pending_verification.11c3bece.svg";